// ═══════════════════════════════════════════════════════════════════
//  modules/tickets/constantes.js
//  STATUS_COLORS · PRIORITY_COLORS
// ═══════════════════════════════════════════════════════════════════

export const STATUS_COLORS = {
  ouvert: { bg: "#3D2D00", text: "#E3B341", label: "Ouvert" },
  ferme: { bg: "#1C2333", text: "#7D8590", label: "Fermé" },
};

export const PRIORITY_COLORS = {
  haute: { bg: "#3D1515", text: "#F85149" },
  normale: { bg: "#1C2333", text: "#7D8590" },
};
